import { render } from "./ClassListCard2.vue?vue&type=template&id=4bd14a8a&scoped=true"
import script from "./ClassListCard2.vue?vue&type=script&lang=js"
export * from "./ClassListCard2.vue?vue&type=script&lang=js"

import "./ClassListCard2.vue?vue&type=style&index=0&id=4bd14a8a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bd14a8a"]])

export default __exports__